 <template>
  <sound-measurements />
</template>

<script>
// @ is an alias to /src
import  SoundMeasurements from "@/components/Instrumentation/SoundMeasurements.vue";

export default {
  name: "Home",
  components: {
    SoundMeasurements,
  },
};
</script>
